module.exports = __webpack_public_path__ + "img/ios-icon.276604d4.png";